/** @format */

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BarChartIcon from '@mui/icons-material/BarChart';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HistoryIcon from '@mui/icons-material/History';
import {Box, Typography} from '@mui/material';
import type {Theme} from '@mui/material/styles';
import {styled} from '@mui/material/styles';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

export const Header = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'row',
  marginBottom: theme.spacing(6),
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const Title = styled(Typography)(() => ({
  fontSize: '28px',
  fontWeight: '700',
}));

interface ProjectButtonsWrapperProps {
  isShownStatusChip: boolean;
}

export const ProjectButtonsWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'isShownStatusChip',
})<ProjectButtonsWrapperProps>(({theme, isShownStatusChip}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  background: isShownStatusChip ? theme.palette.figma_red_3?.main : 'transparent',
  outline: isShownStatusChip ? `1px solid ${theme.palette.figma_red_3?.main}` : 'none',
  borderRadius: '8px',
}));

export const ProjectButton = styled(PrimaryMediumButton)(({theme}) => ({
  height: '48px',
  padding: theme.spacing(0, 4),
  borderRadius: theme.spacing(2),
  background: theme.palette.semantic_dark?.surface.surface2,
  color: theme.palette.semantic_dark?.surface.onSurface,
  gap: theme.spacing(2),
  fontSize: '14px',
  fontWeight: 400,
  whiteSpace: 'pre-line',
  textAlign: 'left',

  '&:hover': {
    background: theme.palette.semantic_dark?.surface.surface3,
  },
}));

const projectButtonIconStyle = ({theme}: {theme: Theme}) => ({
  fontSize: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
});

export const StyledHistoryIcon = styled(HistoryIcon)(projectButtonIconStyle);
export const StyledEditIcon = styled(EditOutlinedIcon)(projectButtonIconStyle);
export const StyledBarChartIcon = styled(BarChartIcon)(projectButtonIconStyle);
export const StyledAutoAwesomeIcon = styled(AutoAwesomeIcon)(projectButtonIconStyle);

export const BreadcrumbsWrapper = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(8),
}));

export const TitleWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
}));
